'use strict';

/**
 * View for rendering a single storage in the select/update location modal
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/select-storages-item.hbs');

var SelectStoragesItemView = ColidoItemView.extend({
    wrapItem: false,

    template: template,

    ui: {
        'noChild': '.no-child',
        'hasChild': '.has-child',
        'addChild': '[data-action="add-storage"]',
    },

    events: {
        'click @ui.noChild': 'onClickItem',
        'click @ui.hasChild': 'onClickItem',
        'click @ui.addChild': 'onAddChild',
    },

    /**
     * Is triggered, when the item is klicked
     * We will notify the layout view with the details
     */
    onClickItem: function(event) {
        var level = this.$el.parents('.lane').data('level');
        var method = this.model.hasSubStorage() ? 'storage:goto' : 'storage:selected';
        this.triggerMethod(method, level, this.model);
    },

    /**
     * Is triggered, when the item is klicked
     * We will notify the layout view with the details
     */
    onAddChild: function() {
        var level = this.$el.parents('.lane').data('level');
        this.triggerMethod('storage:add', level, this.model);
    },
});

module.exports = SelectStoragesItemView;